import classNames from 'classnames';
import { InputHTMLAttributes, LegacyRef, forwardRef } from 'react';

import useToggleState from '~utils/hooks/useToggleState';

import s from './Input.module.css';

const InputLocked = (
  { className, ...rest }: InputHTMLAttributes<HTMLInputElement>,
  ref: LegacyRef<HTMLInputElement>,
) => {
  const [locked, toggleLock] = useToggleState(true);

  return (
    <div className="relative">
      <input
        ref={ref}
        disabled={locked}
        className={classNames(s.control, className, { [s.controlLocked]: locked })}
        {...rest}
      />
      {locked && (
        <button className={s.lockButton} onClick={toggleLock}>
          Usar otro
        </button>
      )}
    </div>
  );
};

export default forwardRef(InputLocked);
